import axios from 'axios';
import { UserSignData } from '../../ts/interfaces/user';

interface SaveUserSignDataParams {
  data: UserSignData;
  tutorId: number;
  patientId: string;
  quoteId: string;
}

export const saveUserSignDataService = async ({
  data,
  tutorId,
  patientId,
  quoteId,
}: SaveUserSignDataParams) => {
  try {
    const response = await axios.post(`/users/savesigndata`, { tutorId, patientId, quoteId, data });

    const returnValue = response.data.data.userUpdate as UserSignData;
    return returnValue;
  } catch (err) {
    return 'verifyInvalid';
  }
};
